import { type Lang, COPY } from "../copy.js";

export function Footer({ lang }: { lang: Lang }) {
  const t = COPY[lang];
  return (
    <footer className="foot">
      <div className="wrap">
        <p className="rsvp-by">{t.footer.rsvpBy}</p>
        <p
          style={{
            fontFamily: "'Instrument Serif', serif",
            fontStyle: "italic",
            fontSize: 15,
            margin: 0,
            color: "var(--ink-soft)",
          }}
        >
          {t.footer.or}
        </p>
        <div className="sep-stars">✦ ✦ ✦</div>
        <div className="sig">{t.footer.sig}</div>
        <a className="url" href={`https://${t.footer.url}`}>
          {t.footer.url}
        </a>
      </div>
    </footer>
  );
}
